"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createCatalogsExportSummaryColumns = void 0;
function createCatalogsExportSummaryColumns() {
    return [
        {
            field: 'gattung',
            headerName: 'Gattung',
            editable: false,
            type: 'derivedColumn'
        },
        {
            field: 'xar',
            headerName: 'xAr',
            editable: true,
        },
        {
            field: 'art',
            headerName: 'Art',
            editable: true,
        },
        {
            field: 'zusatz',
            headerName: 'Zusatz',
            editable: true,
        },
        {
            field: 'sorte',
            headerName: 'Sorte',
            editable: true,
        },
        {
            field: 'farbtyp',
            headerName: 'Farbtyp',
            editable: true,
        },
        {
            field: 'sortenschutz',
            headerName: 'Sortenschutz',
            editable: true,
        },
        {
            field: 'blutenfarbe_detail',
            headerName: 'Blütenfarbe Detail',
            editable: true,
        },
        {
            field: 'blattfarbe_detail',
            headerName: 'Blattfarbe Detail',
            editable: true,
        },
        {
            field: 'vk_argument',
            headerName: 'VK-Argument',
            editable: true,
        },
        {
            field: 'heimische_wildstaude',
            headerName: 'Heimische Wildstaude',
            editable: true,
        },
        {
            field: 'gartenschatze',
            headerName: 'Gartenschätze',
            editable: true,
        },
        {
            field: 'new_string',
            headerName: 'Neu',
            editable: true,
        },
        {
            field: 'catalog_summary',
            headerName: 'Katalog-Text',
            minWidth: 300,
            initialWidth: 300,
            editable: false,
            type: 'derivedColumn',
        },
        {
            field: 'number_of_chars',
            headerName: 'Anzahl Zeichen',
            editable: true,
            type: 'derivedColumn',
            filter: 'agNumberColumnFilter',
            valueGetter: params => {
                return params.data.catalog_summary ? params.data.catalog_summary.length : 0;
            }
        },
    ];
}
exports.createCatalogsExportSummaryColumns = createCatalogsExportSummaryColumns;
